import { Grid,Stack,TextField } from "@mui/material";
import { useContext } from "react";
import { NewFormContext } from "../../../context/NewFormContext";
import { ChecklistSubitem,ChecklistType } from "../../../types/checklist/types";

type props = {
  subitem: ChecklistSubitem;
  itemId: string;
  indexSubitem: number
};
export default function Placa({ subitem, itemId, indexSubitem }: props) {
  const { setModelo } = useContext(NewFormContext);
  function handleValue(value: string) {
    setModelo((prev: ChecklistType) => ({

      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) =>
              subitem.id === indexSubitem
                ? {
                  ...subitem, padrao: value
                } : subitem
            )
          }
          : item
      )
    }));
  }

  const placaCarro = (value: string) => {
    return value
      .toUpperCase()
      .replace(/\W/, '')
      .replace(/(\w)(\W)/, '$1')
      .replace(/^(\d)/, '')
      .replace(/^(\w)(\d)/, '$1')
      .replace(/^(\w)(\w)(\d)/, '$1$2')
      .replace(/^(\w{3})(\D)/, '$1')
      .replace(/^(\w{5})(\D)/, '$1')
      .replace(/^(\w{6})(\D)/, '$1')
      .replace(/^(\D{3})(\w)/, '$1-$2')
      .slice(0, 8);
  };

  return (
    <Stack direction='row' justifyContent='flex-start' alignItems='flex-start' width='100%'>
      <Grid container spacing={1} width='100%'>
        <Grid size={4}>
          <TextField
            fullWidth
            value={subitem.padrao}
            onChange={(event) => handleValue(placaCarro(event.target.value))}
            label='Valor padrão' />
        </Grid>
        <Grid size={4}>
        </Grid>
      </Grid>
    </Stack >
  );
}
